import VehicleLevel from '@/enums/VehicleLevel';
import VehicleType from '@/enums/VehicleType';
import CampaignVehicleLevel from '@/enums/CampaignVehicleLevel';

export default class SearchQuery {
  public vehicleLevel: VehicleLevel = VehicleLevel.Derivative;

  public vehicleType: VehicleType = VehicleType.Car;

  public manufacturerIds: number[] | null = null;

  public rangeIds: number | null = null;

  public bodystyles: string[] | null = null;

  public fuelTypes: string[] | null = null;

  public transmissions: string | null = null;

  public doors: number | null = null;

  public trims: string[] | null = null;

  public derivativeId: number | null = null;

  public modelId: number | null = null;

  public campaignVehicleLevel: CampaignVehicleLevel = CampaignVehicleLevel.None;

  public engineSize: number | null = null;

  public specificColour: string | null = null;

  public basicColour: string | null = null;

  [propName: string]: any;
}
